import React from 'react';
import AppModal from '../ui/AppModal';
import SourceProfilesList from './SourceProfilesList';

function RequirementRecruitersModal({
  show,
  onHide,
  title,
  subtitle,
  recruitersData = [],
  initialStatusFilter = '',
  noActionFilter = false,
  scopedCandidates = null,
  onViewCandidate,
  highlightProfileId = '',
}) {
  return (
    <AppModal
      show={show}
      onHide={onHide}
      title={title}
      subtitle={subtitle}
      size="xl"
      fullscreen="lg-down"
    >
      <SourceProfilesList
        recruitersData={recruitersData}
        initialStatusFilter={initialStatusFilter}
        noActionFilter={noActionFilter}
        scopedCandidates={scopedCandidates}
        onViewCandidate={onViewCandidate}
        highlightProfileId={highlightProfileId}
        resetKey={show ? `${subtitle || 'open'}` : 'closed'}
      />
    </AppModal>
  );
}

export default RequirementRecruitersModal;
